module.exports = __webpack_public_path__ + "img/banner2_7_th.ba0d55fd.png";